const DEFAULT_STACK_BEHAVIOR = 'replace';
const DEFAULT_DISMISS_ON_PAN_DOWN = true;
export { DEFAULT_STACK_BEHAVIOR, DEFAULT_DISMISS_ON_PAN_DOWN };
//# sourceMappingURL=constants.js.map